import { Link } from "react-router-dom";

export const SERVICE_TIERS = [
  {
    id: "home",
    tag: "Home Support",
    title: "Home User Fix",
    desc: "Wireless sync, offline printer status, Mac/Windows driver installation, and PIXMA ink line flushing.",
    price: "From $49 remote",
    image:
      "https://images.unsplash.com/photo-1708793699492-5fa208f52dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxob21lJTIwZGVzayUyMHdpcmVsZXNzJTIwcHJpbnRlcnxlbnwwfHx8fDE3OTE5OTU2NDV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Home desk with a wireless printer being fixed",
    recommended: false,
  },
  {
    id: "office",
    tag: "Small Office",
    title: "Office Dispatch",
    desc: "MAXIFY and imageRUNNER paper path maintenance, network printer sharing, scan-to-email fixes, and fast on-site callouts.",
    price: "From $119 on-site",
    image:
      "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBsYXNlciUyMHByaW50ZXIlMjByZXBhaXJ8ZW58MHx8fHwxNzkxOTk1NjQ1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Technician servicing an office multifunction laser printer",
    recommended: true,
  },
  {
    id: "remote",
    tag: "Live Remote",
    title: "Instant Remote",
    desc: "Secure live screen connection. Immediate fix for spooler hangs, driver conflicts, and test page streaks.",
    price: "From $39 fix",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxsYXB0b3AlMjBzY3JlZW4lMjBzaGFyaW5nJTIwdGVjaCUyMHN1cHBvcnR8ZW58MHx8fHwxNzkxOTk1NjQ1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Technician running a remote screen-sharing support session",
    recommended: false,
  },
];

export default function ServiceCard({ tier }) {
  return (
    <div
      data-testid={`service-card-${tier.id}`}
      className={`bg-white border-2 p-6 flex flex-col justify-between relative ${
        tier.recommended
          ? "border-poster-accent shadow-[4px_4px_0px_#0284C7]"
          : "border-poster-ink shadow-[4px_4px_0px_#0F172A]"
      }`}
    >
      {tier.recommended && (
        <div className="absolute -top-3 right-4 px-2 py-0.5 bg-poster-accent text-white text-[10px] font-mono-lbl uppercase font-bold">
          Recommended
        </div>
      )}
      <div className="h-40 overflow-hidden mb-5 border border-poster-border relative d3-drift">
        <img src={tier.image} alt={tier.alt} className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-poster-ink text-white text-[10px] font-mono-lbl uppercase">
          {tier.tag}
        </div>
      </div>
      <div>
        <h3 className="font-poster text-2xl uppercase text-poster-ink">{tier.title}</h3>
        <p className="text-xs text-slate-600 mt-2 leading-relaxed">{tier.desc}</p>
      </div>
      <div className="mt-6 pt-4 border-t border-slate-200 flex justify-between items-center">
        <span className="font-mono-lbl text-xs font-bold text-poster-ink">{tier.price}</span>
        <Link
          to="/contact"
          data-testid={`service-card-${tier.id}-choose`}
          className="text-xs font-mono-lbl uppercase font-bold text-poster-accent hover:underline"
        >
          Choose &rarr;
        </Link>
      </div>
    </div>
  );
}
